const ImageRenderer = ({ url, height = '80vh', width = '100%' }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: height,
            width: width,
            overflow: 'hidden',
            background: '#0F172A',
        }}
    >
        <img
            src={url}
            alt="Preview"
            style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: 4,
            }}
        />
    </div>
);

export { ImageRenderer };